/**
 * Created by xuyq on 2021/1/22.
 */

export default {
    system:{
        success:'Successful operation',
        logout:'Logout'
    }
}
